import { makeStyles } from 'tss-react/mui';

export default makeStyles<{ indent: number }, 'text'>({ name: 'MenuItem', uniqId: 'b46SBz' })(
    (_, { indent }, classes) => ({
        root: {
            textDecoration: 'none',
            height: 40,
            color: '#232323',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            borderRadius: 8,
            '&:hover': {
                background: '#F8F8F8'
            }
        },
        _active: {
            background: '#F8F8F8'
        },
        _expanded: {},
        _adaptive: {
            [`&.${classes.text}`]: {
                transition: 'all 0.2s linear',
                '@media (max-width: 1024px)': {
                    width: 0,
                    display: 'none'
                },
                '@media (max-width: 460px)': {
                    width: 'initial',
                    display: 'block'
                }
            }
        },
        icon: {
            width: 24,
            height: 24,
            margin: 12
        },
        spacer: {
            height: '100%',
            minWidth: indent * 48,
            maxWidth: indent * 48
        },
        text: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '21px',
            letterSpacing: '-0.28px'
        },
        tooltip: {
            padding: 12,
            borderRadius: 8,
            background: '#2D2D2D',
            color: '#FFF',
            textAlign: 'center',
            fontSize: 13,
            fontWeight: 500,
            lineHeight: '150%',
            letterSpacing: '-0.26px'
        }
    })
);
